/* eslint-disable max-lines */
// 9fbef606107a605d69c0edbcd8029e5d
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  getAPIConfig,
  readCookie,
  getDateRange,
  routerPush,
  normalizeUSPhone,
  getDateInformation,
  isClient,
  getDateObject,
} from '@tcp/core/src/utils';
import logger from '@tcp/core/src/utils/loggerInstance';
import { getEdd } from '@tcp/core/src/services/abstractors/CnC/edd';
import {
  DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY,
  ORDER_TYPE,
} from '@tcp/core/src/components/features/CnC/Checkout/Checkout.constants';
import {
  getShippingMethods,
  updateShippingAddressMethodAndGiftOption,
} from '@tcp/core/src/services/abstractors/CnC/CheckoutSFCC';
import { addEditStoreDetailsApi } from '@tcp/core/src/services/abstractors/SFCC/addEditStoreDetails';
import { formatNonCachedResponse } from '@tcp/core/src/components/features/CnC/BagPage/container/BagPage.saga';
import { DUMMY_ADDRESS_VALUES_FOR_AFTER_PAY } from '@tcp/core/src/components/common/organisms/AfterPayPayment/AfterPay.constants';
import {
  capitalizeWords,
  dateFormatter,
  getESTDateTime,
  getFormattedPreOrderDateCartPage,
} from '@tcp/core/src/utils/utils';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import styles from '../styles/AfterPayExpress.view.style';
import AfterPayExpressDrawer from './AfterPayExpressDrawer.view';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../utils/labels/labelUtilty';
import BAGPAGE_LABELS from '../../../../features/CnC/BagPage/container/Bagpage.labels';

const afterPayButtom = 'afterpay-button';

const getTrimmedValue = (value) => (value || '').trim();

const getTaxAmount = (pickupAddress) => {
  return pickupAddress?.storeDetails?.taxTotal || pickupAddress?.updateShipping?.taxTotal;
};

const getTaxToShow = (taxAmount, calculatedEstimatedTax) => {
  return typeof taxAmount === 'number' ? taxAmount : calculatedEstimatedTax;
};

const getBossRangeEligibility = (isBossEligible, maxBossDate, minBossDate) => {
  return isBossEligible && (maxBossDate || minBossDate);
};

const getShipingPayload = (orderType, shippingContactPayload) => {
  return orderType === ORDER_TYPE.ECOM_MIX
    ? shippingContactPayload.shippingObject
    : shippingContactPayload;
};

export const getEDDParam = (data, cartOrderItems, currentOrderId) => {
  const itemsList =
    cartOrderItems &&
    cartOrderItems.size &&
    cartOrderItems.map((item) => {
      const productInfo = item.get('productInfo');
      const itemInfo = item.get('itemInfo');
      return {
        orderItemId: itemInfo.get('itemId'),
        skuId: productInfo.get('skuId'),
        skuQty: itemInfo.get('quantity'),
      };
    });
  return {
    skuList: itemsList,
    orderId: currentOrderId,
    state: data.state,
    zipCode: data.postcode,
  };
};

const getStoreAddress = (userDefaultPickupStore = {}) => {
  const storeName = userDefaultPickupStore?.basicInfo?.storeName || '';
  const storePhone = userDefaultPickupStore?.basicInfo?.phone || '';
  const storeStateName = userDefaultPickupStore?.basicInfo?.address?.state || '';
  const storeLine1 = userDefaultPickupStore?.basicInfo?.address?.addressLine1 || '';
  const storeCity = userDefaultPickupStore?.basicInfo?.address?.city || '';
  const storeZipCode = userDefaultPickupStore?.basicInfo?.address?.zipCode || '';
  return {
    storeName,
    storePhone,
    storeStateName,
    storeLine1: capitalizeWords(storeLine1),
    storeCity: capitalizeWords(storeCity),
    storeZipCode,
    country: userDefaultPickupStore?.basicInfo?.address?.country || 'US',
  };
};

export const formatShippingDTO = (data = {}, shipmentId, fallbackUserContact) => {
  const fname = (data.name && data.name.split(' ')[0]) || fallbackUserContact.firstName;
  const lname = (data.name && data.name.split(' ')[1]) || fallbackUserContact.lastName;
  return {
    shippingAddressDTO: {
      c_deliveryIndicator: '1',
      shippingAddress: {
        address1: data.address1 || DUMMY_ADDRESS_VALUES_FOR_AFTER_PAY.address1,
        address2: data.address2,
        c_addressId: data.addressId || '',
        c_addressType: 'ShippingAndBilling',
        c_emailAddress:
          fallbackUserContact.emailAddress || DUMMY_ADDRESS_VALUES_FOR_AFTER_PAY.email,
        city: data.suburb || DUMMY_ADDRESS_VALUES_FOR_AFTER_PAY.city,
        countryCode: data.countryCode || 'US',
        firstName: fname,
        lastName: lname,
        phone: normalizeUSPhone(data.phoneNumber) || DUMMY_ADDRESS_VALUES_FOR_AFTER_PAY.phone,
        postalCode: data.postcode || '00000',
        stateCode: data.state || DUMMY_ADDRESS_VALUES_FOR_AFTER_PAY.state,
      },
    },
    shippingMethod: { id: shipmentId },
  };
};

export const formatShippingDTOobj = (data = {}, shipmentId) => {
  return {
    shippingAddressDTO: {
      c_deliveryIndicator: '1',
      shippingAddress: {
        address1: data.addressLine1 || DUMMY_ADDRESS_VALUES_FOR_AFTER_PAY.address1,
        address2: data.addressLine2,
        c_addressId: data.addressId || '',
        c_addressType: 'ShippingAndBilling',
        c_emailAddress: data.emailAddress || DUMMY_ADDRESS_VALUES_FOR_AFTER_PAY.email,
        city: data.city || DUMMY_ADDRESS_VALUES_FOR_AFTER_PAY.city,
        countryCode: data.country || 'US',
        firstName: data.firstName,
        lastName: data.lastName,
        phone: data.phone || DUMMY_ADDRESS_VALUES_FOR_AFTER_PAY.phone,
        postalCode: data.zipCode || '00000',
        stateCode: data.state || DUMMY_ADDRESS_VALUES_FOR_AFTER_PAY.state,
      },
    },
    shippingMethod: { id: shipmentId },
  };
};

export const getShippingContactPayload = (
  data = {},
  orderType,
  shipmentId,
  fallbackUserContact,
  isLoggedIn,
  firstName,
  lastName
) => {
  const fname = isLoggedIn
    ? firstName
    : (data.name && data.name.split(' ')[0]) || fallbackUserContact.firstName;
  const lname = isLoggedIn
    ? lastName
    : (data.name && data.name.split(' ')[1]) || fallbackUserContact.lastName;
  if (orderType === ORDER_TYPE.PURE_ECOM) {
    return formatShippingDTO(data, shipmentId, fallbackUserContact);
  }
  if (orderType === ORDER_TYPE.ECOM_MIX) {
    return {
      shippingObject: formatShippingDTO(data, shipmentId, fallbackUserContact),
      pickUpObj: {
        firstName: fname,
        lastName: lname,
        email: fallbackUserContact.emailAddress,
        phone: normalizeUSPhone(data.phoneNumber) || fallbackUserContact.phoneNumber,
      },
    };
  }
  return {
    firstName: fname,
    lastName: lname,
    email: fallbackUserContact.emailAddress,
    phone: normalizeUSPhone(data.phoneNumber) || fallbackUserContact.phoneNumber,
  };
};

export const formatShippingData = (data = {}, fallbackUserContact) => {
  const fname = (data.name && data.name.split(' ')[0]) || fallbackUserContact.firstName;
  const lname = (data.name && data.name.split(' ')[1]) || fallbackUserContact.lastName;
  return {
    address: {
      addressId: data.addressId || '',
      addressLine1: data.address1,
      addressLine2: null,
      city: data.suburb,
      country: 'US',
      firstName: fname || DUMMY_ADDRESS_VALUES_FOR_AFTER_PAY.firstName,
      id: data.id || '001',
      lastName: lname || DUMMY_ADDRESS_VALUES_FOR_AFTER_PAY.lastName,
      phone: normalizeUSPhone(data.phoneNumber) || DUMMY_ADDRESS_VALUES_FOR_AFTER_PAY.phone,
      state: data.state,
      validationCode: null,
      zipCode: data.postcode,
      deliveryIndicator: null,
      emailAddress: fallbackUserContact.emailAddress || DUMMY_ADDRESS_VALUES_FOR_AFTER_PAY.email,
      addressType: 'ShippingAndBilling',
      sameAsShippingAddress: true,
    },
    emailAddress: fallbackUserContact?.emailAddress,
    phoneNumber: normalizeUSPhone(data?.phoneNumber),
    method: { shippingMethodId: data?.id || '001' },
  };
};

export const getCCinfo = ({
  virtualCard,
  reviewFormValues,
  addressId,
  singlePageCheckout,
  token,
  basketId,
  errorLabels,
  isExpressAfterPayPayment,
  orderType,
}) => {
  const { cardNumber, cvc: cvv, expiry, cardType } = virtualCard;
  const expiryValues = expiry ? expiry.split('-') : '';
  const yearExpire = expiryValues?.length ? expiryValues[0] : '';
  const monthExpire = expiryValues?.length > 1 ? expiryValues[1] : '';
  return {
    cardNumber,
    monthExpire,
    yearExpire,
    cvv,
    reviewFormValues,
    cardType,
    addressId,
    singlePageCheckout,
    token,
    isExpressAfterpay: true,
    basketId,
    errorLabels,
    isExpressAfterPayPayment,
    orderType,
  };
};

export const getShippingDesc = ({
  eddData,
  method,
  storeName,
  storeStateName,
  isMixCart,
  preOrderDateRange,
  preOrderDateStr,
  preOrderDates,
  itemsList,
}) => {
  const {
    lbl_edd_arrivesby: arrivesBy,
    lbl_preorder_items_edd: lblPreorderItemsEdd,
    lbl_coupon_afterpay_pickup_from: lblCouponAfterpayPickupFrom,
  } = getLabelFromCopyOrFromTranslation('checkout.bagPage', BAGPAGE_LABELS);

  const afterpayLabels = {
    afterpayPreOrderEstimate: renderLabel(lblPreorderItemsEdd, 'lbl_preorder_items_edd'),
    afterpayPickupFrom: renderLabel(lblCouponAfterpayPickupFrom, 'lbl_coupon_afterpay_pickup_from'),
  };

  let ShippingDesc = '';
  const ifEddAvailable =
    eddData?.orderEddDates?.maxDates && Object.keys(eddData?.orderEddDates?.maxDates).length !== 0;

  const eddDateToShow =
    ifEddAvailable && getDateRange(eddData?.orderEddDates, method.code, false, true);

  if (preOrderDateRange) {
    if (preOrderDates?.length === itemsList?.size) {
      ShippingDesc = preOrderDateRange;
    } else if (ifEddAvailable && eddDateToShow) {
      ShippingDesc = `${arrivesBy} ${eddDateToShow} ${afterpayLabels.afterpayPreOrderEstimate}  ${preOrderDateStr}`;
    } else {
      ShippingDesc = `${afterpayLabels.afterpayPreOrderEstimate}  ${preOrderDateStr}`;
    }
  } else {
    ShippingDesc = `${
      ifEddAvailable && eddDateToShow
        ? `${arrivesBy} ${eddDateToShow}` || method.shippingSpeed
        : method.shippingSpeed
    } ${
      isMixCart ? ` | ${afterpayLabels.afterpayPickupFrom} ${storeName}, ${storeStateName}` : ''
    }`;
  }
  return ShippingDesc;
};

class AfterPayExpress extends Component {
  constructor(props) {
    super(props);
    this.afterpayButton = null;
    this.myRef = React.createRef();
  }

  componentDidUpdate(prevProps) {
    const {
      shouldExpressAfterPayPopupOpen,
      successOnRemoveCouponApi,
      isPlccPostApplicationExperienceEnabled,
    } = this.props;
    if (!this.isAfterpayInProgress) {
      this.initializeExpressAfterPay();
    }
    if (
      prevProps.successOnRemoveCouponApi !== successOnRemoveCouponApi &&
      successOnRemoveCouponApi &&
      isPlccPostApplicationExperienceEnabled
    ) {
      this.afterpayButton?.click();
    }

    if (
      isClient() &&
      prevProps.shouldExpressAfterPayPopupOpen !== shouldExpressAfterPayPopupOpen &&
      shouldExpressAfterPayPopupOpen
    ) {
      const node = this.myRef.current;
      const [firstButton] = node?.getElementsByTagName(afterPayButtom);
      this.afterpayButton = firstButton;
      this.afterpayButton.click();
    }
  }

  getPreOrderDate = (cartOrderItems) => {
    const preOrderDates = [];
    if (!cartOrderItems?.size) {
      return preOrderDates;
    }
    cartOrderItems.forEach((productDetail) => {
      if (productDetail?.variantPreOrderMap || productDetail?.preOrderDate) {
        const variantPreOrderData = productDetail.variantPreOrderMap || productDetail.preOrderDate;
        if (variantPreOrderData) {
          const POD = dateFormatter(variantPreOrderData);
          const today = getESTDateTime();
          const preOrderDate = Date.parse(today) > Date.parse(POD) ? today : POD;
          preOrderDates.push(getDateObject(preOrderDate));
        }
      }
    });
    return preOrderDates;
  };

  toggleDrawer = (value) => {
    const { setAfterPayDrawerActn } = this.props;
    setAfterPayDrawerActn(value);
  };

  getOrderAddress = () => {
    const { shippingAddress, isOrderHasPickup, pickupStoresInCart, fallbackAddress } = this.props;
    const address = Array.isArray(pickupStoresInCart) ? pickupStoresInCart[0] : null;
    let shippingAddressData = shippingAddress;
    if (!shippingAddress) {
      shippingAddressData = fallbackAddress;
    }
    return isOrderHasPickup && address?.addressLine1
      ? {
          addressLine1: address.addressLine1,
          addressLine2: address.addressLine2,
          city: address.city,
          country: address.country,
          firstName: address.firstName,
          lastName: address.lastName,
          state: address.state,
          zipCode: address.zipCode,
          nickName: address.addessKey,
          addressId: address.addressId || '',
        }
      : shippingAddressData || {};
  };

  formatShippingMethods = (
    shipmentMethods,
    {
      eddData,
      orderType,
      storeName,
      storeStateName,
      preOrderDateRange,
      preOrderDateStr,
      preOrderDates,
      itemsList,
      taxAmount,
    }
  ) => {
    const { ledgerSummaryData } = this.props;
    const isMixCart = orderType === ORDER_TYPE.ECOM_MIX;
    const {
      subTotal = 0,
      shippingTotal = 0,
      giftServiceTotal = 0,
      giftCardsTotal = 0,
      couponsTotal = 0,
      savingsTotal = 0,
      calculatedEstimatedTax = 0,
    } = ledgerSummaryData || {};
    const orderTotal = Math.abs(
      Number(
        subTotal + shippingTotal + giftServiceTotal - giftCardsTotal - couponsTotal - savingsTotal
      )
    ).toFixed(2);
    const taxToShow = typeof taxAmount === 'number' ? taxAmount : calculatedEstimatedTax;

    return shipmentMethods.map((method) => {
      return {
        id: method.id,
        name: method.displayName,
        description: getShippingDesc({
          eddData,
          method,
          storeName,
          storeStateName,
          isMixCart,
          preOrderDateRange,
          preOrderDateStr,
          preOrderDates,
          itemsList,
        }),
        shippingAmount: { amount: `${method.price}`, currency: 'USD' },
        orderAmount: {
          amount: `${(Number(orderTotal) + method.price + Number(taxToShow)).toFixed(2)}`,
          currency: 'USD',
        },
        methodObj: method,
      };
    });
  };

  minMaxDateRange = (minBossDate, maxBossDate) => {
    if (minBossDate?.month === maxBossDate?.month && minBossDate?.date === maxBossDate?.date) {
      return `${minBossDate?.month} ${minBossDate?.date}`;
    }
    return `${minBossDate?.month} ${minBossDate?.date} - ${maxBossDate?.month} ${maxBossDate?.date}`;
  };

  getMinMaxDates = (userDefaultStore) => {
    const minDate =
      userDefaultStore?.storeBossInfo?.startDate || userDefaultStore?.features?.bossMinDate;
    const maxDate =
      userDefaultStore?.storeBossInfo?.endDate || userDefaultStore?.features?.bossMaxDate;
    const pasedMin = minDate?.replace(/-/g, '/');
    const pasedMax = maxDate?.replace(/-/g, '/');

    const maxBossDate = pasedMax ? getDateInformation(pasedMax) : '';
    const minBossDate = pasedMin ? getDateInformation(pasedMin) : '';
    return {
      maxBossDate,
      minBossDate,
    };
  };

  fetchShippingMethods = async (
    data,
    {
      orderBalanceTotal,
      cartOrderItems,
      currentOrderId,
      isNonEcom,
      orderType,
      userDefaultPickupStore,
      preOrderDateRange,
      preOrderDateStr,
      preOrderDates,
      itemsList,
    }
  ) => {
    const {
      shipmentId,
      fallbackUserContact,
      ledgerSummaryData,
      setEstimatedTax,
      estimatedTaxReduxTTLValue,
      isLoggedIn,
      firstName,
      lastName,
    } = this.props;
    const shippingContactPayload = getShippingContactPayload(
      data,
      orderType,
      shipmentId,
      fallbackUserContact,
      isLoggedIn,
      firstName,
      lastName
    );
    let taxAmount = null;
    const shipingPayload = getShipingPayload(orderType, shippingContactPayload);
    if (orderType === ORDER_TYPE.PURE_ECOM || orderType === ORDER_TYPE.ECOM_MIX) {
      try {
        const res = await updateShippingAddressMethodAndGiftOption(shipingPayload);
        taxAmount = res?.data?.updateShipping?.taxTotal;
        this.containsError = false;
      } catch (err) {
        logger.error('Afterpay Shipping method update', err);
        this.containsError = true;
      }
    } else {
      const pickupAddress = await this.addStoreAddressAndShippingMethod(
        shippingContactPayload,
        orderType
      );
      taxAmount = getTaxAmount(pickupAddress);
    }

    const storeName = userDefaultPickupStore?.basicInfo?.storeName || '';
    const storeStateName = userDefaultPickupStore?.basicInfo?.address?.state || '';
    const isBossEligible = userDefaultPickupStore?.storeBossInfo?.isBossEligible;
    const { maxBossDate, minBossDate } = this.getMinMaxDates(userDefaultPickupStore);
    const minMaxBossRangeString = getBossRangeEligibility(isBossEligible, maxBossDate, minBossDate)
      ? this.minMaxDateRange(minBossDate, maxBossDate)
      : '';
    const {
      subTotal = 0,
      shippingTotal = 0,
      giftServiceTotal = 0,
      giftCardsTotal = 0,
      couponsTotal = 0,
      savingsTotal = 0,
      calculatedEstimatedTax = 0,
    } = ledgerSummaryData || {};

    const orderTotal = Math.abs(
      Number(
        subTotal + shippingTotal + giftServiceTotal - giftCardsTotal - couponsTotal - savingsTotal
      )
    ).toFixed(2);
    const taxToShow = getTaxToShow(taxAmount, calculatedEstimatedTax);
    if (isNonEcom && orderType !== 'ECOM_MIX') {
      setEstimatedTax({ tax: taxToShow, estimatedTaxReduxTTLValue });
      return [
        {
          id: 'pickup-store-123',
          name: 'Pickup in store',
          description: `${
            orderType === ORDER_TYPE.PURE_BOSS
              ? ` Pickup By : ${minMaxBossRangeString} `
              : ' Pickup Today '
          }`,
          shippingAmount: { amount: '0', currency: 'USD' },
          taxAmount: { amount: '0', currency: 'USD' },
          orderAmount: {
            amount: `${(Number(orderTotal) + Number(taxToShow)).toFixed(2)}`,
            currency: 'USD',
          },
        },
      ];
    }
    const shipmentMethods = await getShippingMethods(
      { zipCode: data.postcode, state: data.state, addressLine1: data.address1 },
      {},
      'ChangeEvent'
    );
    const eddData = (await getEdd(getEDDParam(data, cartOrderItems, currentOrderId))) || null;
    return this.formatShippingMethods(shipmentMethods || [], {
      orderBalanceTotal,
      eddData,
      orderType,
      storeName,
      storeStateName,
      preOrderDateRange,
      preOrderDateStr,
      preOrderDates,
      itemsList,
      taxAmount,
    });
  };

  getCustomerInfo = () => {
    const { shippingPhoneAndEmail = {}, pickupInformation, isOrderHasPickup } = this.props;

    return pickupInformation && isOrderHasPickup ? pickupInformation : shippingPhoneAndEmail;
  };

  setStyles = () => {
    const shadowButton = this.afterpayButton?.shadowRoot?.querySelector('button');
    if (shadowButton) {
      shadowButton.setAttribute('style', 'cursor: pointer');
    }
  };

  getErrMsgAfterpay = (cartHaveGCItem, errorLabels) => {
    if (cartHaveGCItem) {
      return errorLabels.AFTERPAY_CHECKOUT_GC_ERROR;
    }
    return errorLabels.AFTERPAY_CHECKOUT_ERROR;
  };

  addStoreAddressAndShippingMethod = async (shippingContact, orderType) => {
    const { getSetPickupValuesAction } = this.props;
    const basketId = readCookie('basketId');
    if (orderType === ORDER_TYPE.ECOM_MIX) {
      const { shippingObject, pickUpObj } = shippingContact;
      const response = await addEditStoreDetailsApi({ ...pickUpObj, basketId });
      if (response) {
        return updateShippingAddressMethodAndGiftOption(shippingObject);
      }
      return response;
    }
    // eslint-disable-next-line sonarjs/prefer-immediate-return
    const response = await addEditStoreDetailsApi({ ...shippingContact, basketId });
    const pickupContectDetails = {
      firstName:
        shippingContact?.firstName === DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY.firstName
          ? null
          : shippingContact?.firstName,
      lastName:
        shippingContact?.lastName === DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY.lastName
          ? null
          : shippingContact?.lastName,
      emailAddress:
        shippingContact?.email === DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY.email
          ? null
          : shippingContact?.email,
      phoneNumber:
        shippingContact?.phone === DUMMY_ADDRESS_VALUES_FOR_APPLE_PAY.phone
          ? null
          : shippingContact?.phone,
    };
    getSetPickupValuesAction(pickupContectDetails);

    return response;
  };

  fetchInventory = () => {
    const {
      startExpressCheckoutHandler,
      trackAnalyticsClick,
      isLoggedIn,
      allCouponList,
      couponApplied,
      bossGCAndPreOrderCase,
      toggelBossModal,
      setAfterPayFlow,
    } = this.props;
    trackAnalyticsClick({ customEvents: ['event94'], expressCheckoutCTAType: 'Afterpay' }, {});
    if (bossGCAndPreOrderCase) {
      toggelBossModal();
      setAfterPayFlow(true);
    } else if (isLoggedIn && allCouponList?.size > 0 && !couponApplied) {
      this.toggleDrawer(true);
    } else {
      startExpressCheckoutHandler();
    }
  };

  continueWithPayment = () => {
    const { startExpressCheckoutHandler, setAfterPayPaymentProgressActn } = this.props;
    startExpressCheckoutHandler();
    setAfterPayPaymentProgressActn(true);
    this.toggleDrawer(false);
  };

  resetShippingData = () => {
    const { updateSelectedShippingMethodActn, orderType, shippingAddress } = this.props;
    if (orderType === ORDER_TYPE.PURE_ECOM || orderType === ORDER_TYPE.ECOM_MIX) {
      updateSelectedShippingMethodActn({});
      updateShippingAddressMethodAndGiftOption(formatShippingDTOobj(shippingAddress, null));
    }
  };

  getDateRangeForPreOrderItems = (preOrderDates, ignoreLabel) => {
    const maxDateObj = getDateObject(Math.max.apply(null, preOrderDates));
    const minDateObj = getDateObject(Math.min.apply(null, preOrderDates));
    let rangeDate = null;
    if (maxDateObj && minDateObj) {
      rangeDate = ` ${ignoreLabel ? '' : 'Ships by'} ${getFormattedPreOrderDateCartPage(
        minDateObj,
        true
      )} - ${getFormattedPreOrderDateCartPage(maxDateObj, true)}`;
    }
    if (minDateObj.getTime() === maxDateObj.getTime()) {
      rangeDate = ` ${ignoreLabel ? '' : 'Ship by'} ${getFormattedPreOrderDateCartPage(
        minDateObj,
        true
      )}`;
    }
    return rangeDate;
  };

  initializeExpressAfterPay = () => {
    const {
      cartOrderItems,
      ledgerSummaryData = {},
      reviewFormValues,
      setErrorState,
      errorLabels,
      setLoader,
      currentOrderId,
      cartHaveGCItem,
      singlePageCheckout,
      setShippingAddress,
      updateSelectedShippingMethodActn,
      orderType,
      fallbackAddress,
      fallbackUserContact,
      checkoutWithExpressAfterPay,
      modalInfo,
      isExpressAfterPayPayment,
      setAfterPayPaymentProgressActn,
      userDefaultPickupStore,
      setAfterPayPopupOpenActn,
      setOrderDetailsPartial,
      estimatedTaxReduxTTLValue,
      setEstimatedTax,
    } = this.props;
    const { orderBalanceTotal } = ledgerSummaryData;
    const {
      addressLine1,
      addressLine2,
      city,
      country,
      firstName,
      lastName,
      state,
      zipCode,
      addressId,
    } = this.getOrderAddress() || fallbackAddress;
    const {
      emailAddress,
      phoneNumber,
      firstName: firstNamePickup,
      lastName: lastNamePickup,
    } = this.getCustomerInfo() || fallbackUserContact;

    const isNonEcom = orderType !== ORDER_TYPE.PURE_ECOM;
    const isCartTypePickup = isNonEcom && orderType !== 'ECOM_MIX';

    const itemsList =
      cartOrderItems &&
      cartOrderItems.size &&
      cartOrderItems.map((item) => {
        const productInfo = item.get('productInfo');
        const itemInfo = item.get('itemInfo');
        const miscInfo = item.get('miscInfo');
        return {
          name: productInfo.get('name'),
          sku: productInfo.get('skuId'),
          quantity: itemInfo.get('quantity'),
          pageUrl: productInfo.get('pdpUrl'),
          imageUrl: productInfo.get('imagePath'),
          preOrderDate: itemInfo.get('preOrderDate'),
          variantPreOrderMap: miscInfo.getIn(['variantPreOrderMap', 'preOrderDate']),
          price: {
            amount: itemInfo.get('offerPrice'),
            currency: 'USD',
          },
        };
      });

    const preOrderDates = this.getPreOrderDate(itemsList);
    const preOrderDateRange =
      preOrderDates.length > 0 && this.getDateRangeForPreOrderItems(preOrderDates);
    const preOrderDateStr =
      preOrderDates?.length > 0 && this.getDateRangeForPreOrderItems(preOrderDates, true);
    const node = this.myRef.current;
    const [firstButton] = node.getElementsByTagName(afterPayButtom);
    const errMsgAfterpay = this.getErrMsgAfterpay(cartHaveGCItem, errorLabels);

    const {
      subTotal = 0,
      shippingTotal = 0,
      giftServiceTotal = 0,
      giftCardsTotal = 0,
      couponsTotal = 0,
      savingsTotal = 0,
      calculatedEstimatedTax = 0,
    } = ledgerSummaryData;
    const orderTotal = Math.abs(
      Number(
        subTotal +
          shippingTotal +
          giftServiceTotal -
          giftCardsTotal -
          couponsTotal -
          savingsTotal +
          Number(calculatedEstimatedTax)
      )
    ).toFixed(2);
    this.afterpayButton = firstButton;
    const that = this;
    this.setStyles();
    const onClickHandler = (event) => {
      this.isAfterpayInProgress = true;

      setAfterPayPaymentProgressActn(true);
      if (modalInfo?.showModal) {
        event.stopPropagation();
      } else if (cartHaveGCItem) {
        event.stopPropagation();
        setErrorState({
          errorMessage: errMsgAfterpay,
          component: 'AfterPay',
        });
      } else {
        const fName = firstName || firstNamePickup || '';
        const lName = lastName || lastNamePickup || '';
        this.afterpayButton.merchantReference = `${currentOrderId}`;
        this.afterpayButton.amount = orderTotal.toString();

        this.afterpayButton.currency = 'USD';
        this.afterpayButton.items = JSON.stringify(itemsList);
        this.afterpayButton.consumerPhoneNumber =
          emailAddress !== DUMMY_ADDRESS_VALUES_FOR_AFTER_PAY.email
            ? getTrimmedValue(phoneNumber)
            : '';
        this.afterpayButton.consumerGivenNames = getTrimmedValue(fName);
        this.afterpayButton.consumerSurname = getTrimmedValue(lName);
        this.afterpayButton.consumerEmail =
          emailAddress !== DUMMY_ADDRESS_VALUES_FOR_AFTER_PAY.email
            ? getTrimmedValue(emailAddress)
            : '';
        this.afterpayButton.buyNow = true;
        this.afterpayButton.instorePickup = false;

        if (isCartTypePickup) {
          const pickupStoreAddress = getStoreAddress(userDefaultPickupStore);

          this.afterpayButton.shippingName = pickupStoreAddress.storeName;
          this.afterpayButton.shippingLine1 = pickupStoreAddress.storeLine1;
          this.afterpayButton.shippingLine2 = '';
          this.afterpayButton.shippingArea1 = pickupStoreAddress.storeCity;
          this.afterpayButton.shippingRegion = pickupStoreAddress.storeStateName;
          this.afterpayButton.shippingPostcode = pickupStoreAddress.storeZipCode;
          this.afterpayButton.shippingCountryCode = pickupStoreAddress.country;
          this.afterpayButton.shippingPhoneNumber = pickupStoreAddress.storePhone;
        }

        if (
          zipCode &&
          state &&
          emailAddress !== DUMMY_ADDRESS_VALUES_FOR_AFTER_PAY.email &&
          orderType === ORDER_TYPE.PURE_ECOM
        ) {
          this.afterpayButton.shippingName = `${fName} ${lName}`;
          this.afterpayButton.shippingLine1 = addressLine1;
          this.afterpayButton.shippingLine2 = addressLine2;
          this.afterpayButton.shippingArea1 = city;
          this.afterpayButton.shippingRegion = state;
          this.afterpayButton.shippingPostcode = zipCode;
          this.afterpayButton.shippingCountryCode = country;
          this.afterpayButton.shippingPhoneNumber = phoneNumber;

          this.afterpayButton.billingName = `${fName} ${lName}`;
          this.afterpayButton.billingLine1 = addressLine1;
          this.afterpayButton.billingLine2 = addressLine2;
          this.afterpayButton.billingArea1 = city;
          this.afterpayButton.billingRegion = state;
          this.afterpayButton.billingPostcode = zipCode;
          this.afterpayButton.billingCountryCode = country;
          this.afterpayButton.billingPhoneNumber = phoneNumber;
        }
      }
      return null;
    };

    this.afterpayButton.removeEventListener('click', onClickHandler, true);

    this.afterpayButton.addEventListener('click', onClickHandler, true);

    this.afterpayButton.expressCheckout = {
      region: 'US',
      shippingOptionRequired: true,
      buyNow: true,
      pickup: isCartTypePickup,
      onComplete: (event) => {
        this.isAfterpayInProgress = false;
        setAfterPayPaymentProgressActn(false);
        setLoader(true);
        const { status, virtualCard, token } = event.data;
        const basketId = readCookie('basketId');
        // The consumer confirmed the payment schedule.
        // The virtualCard details can be inserted into your checkout
        if (status === 'SUCCESS') {
          if (that.containsError) {
            routerPush('/checkout', '/checkout');
            setErrorState({
              errorMessage: errMsgAfterpay,
              component: 'AfterPay',
            });
            event.stopPropagation();
          } else {
            const ccInfo = getCCinfo({
              virtualCard,
              reviewFormValues,
              addressId,
              singlePageCheckout,
              token,
              basketId,
              errorLabels,
              isExpressAfterPayPayment,
              orderType,
            });
            checkoutWithExpressAfterPay(ccInfo);
          }
        } else {
          setLoader(false);
          setAfterPayPopupOpenActn(false);
          this.resetShippingData();
          setErrorState({
            errorMessage: errMsgAfterpay,
            component: 'AfterPay',
          });
        }
      },
      onShippingAddressChange: (data, actions) => {
        if (orderType === ORDER_TYPE.PURE_ECOM || orderType === ORDER_TYPE.ECOM_MIX) {
          setShippingAddress(formatShippingData(data, fallbackUserContact));
        }
        that.addressDto = data;

        this.fetchShippingMethods(data, {
          orderBalanceTotal,
          cartOrderItems,
          currentOrderId,
          isNonEcom,
          orderType,
          userDefaultPickupStore,
          preOrderDateRange,
          preOrderDateStr,
          preOrderDates,
          itemsList,
        })
          .then((options) => {
            actions.resolve(options);
            that.containsError = false;
          })
          .catch((err) => {
            logger.error('Afterpay Shipping method fetch', err);
            that.containsError = true;
          });
      },

      onShippingOptionChange: (data) => {
        updateSelectedShippingMethodActn(data?.methodObj);
        if (orderType === ORDER_TYPE.PURE_ECOM || orderType === ORDER_TYPE.ECOM_MIX) {
          const addressRes = updateShippingAddressMethodAndGiftOption(
            formatShippingDTO(that.addressDto, data.id, fallbackUserContact)
          );
          addressRes
            .then((res) => {
              const cartData = res?.data?.updateShipping;
              const { orderDetails } = formatNonCachedResponse(cartData) || {};
              if (orderDetails) {
                setOrderDetailsPartial(orderDetails);
                setEstimatedTax({ tax: orderDetails?.totalTax, estimatedTaxReduxTTLValue });
              }
              that.containsError = false;
            })
            .catch((err) => {
              logger.error('Afterpay Shipping address updation after shipping method change', err);
              that.containsError = true;
            });
        }
      },
    };

    this.afterpayButton.onError = () => {
      this.isAfterpayInProgress = false;
      setAfterPayPaymentProgressActn(false);
      setAfterPayPopupOpenActn(false);
      this.resetShippingData();
      setErrorState({
        errorMessage: errMsgAfterpay,
        component: 'AfterPay',
      });
    };
  };

  render() {
    const { className, showCouponsDrawer } = this.props;
    const { afterpayButtonKey } = getAPIConfig();
    return (
      <div className={className} ref={this.myRef}>
        <button onClick={this.fetchInventory} className="afterpay-ghost-button">
          Afterpay Dummy Button
        </button>
        <afterpay-button
          type="express" // determines checkout type
          afterpayEntryPoint="cart" // options include "product-page", "mini-cart", and "cart"
          afterpayCheckoutButtonLabel="Express Checkout"
          merchantPublicKey={afterpayButtonKey}
        />
        {showCouponsDrawer && (
          <AfterPayExpressDrawer
            continueWithPayment={this.continueWithPayment}
            closeDrawer={this.toggleDrawer}
            showCouponsDrawer={showCouponsDrawer}
            {...this.props}
          />
        )}
      </div>
    );
  }
}

AfterPayExpress.propTypes = {
  className: PropTypes.string,
  checkoutWithAfterPay: PropTypes.func,
  shippingAddress: PropTypes.shape({}).isRequired,
  shippingPhoneAndEmail: PropTypes.shape({}).isRequired,
  cartOrderItems: PropTypes.shape({}).isRequired,
  ledgerSummaryData: PropTypes.shape({}).isRequired,
  currentOrderId: PropTypes.string.isRequired,
  reviewFormValues: PropTypes.string.isRequired,
  pickupStoresInCart: PropTypes.shape({}),
  pickupInformation: PropTypes.shape({}),
  isOrderHasPickup: PropTypes.bool,
  setErrorState: PropTypes.func,
  errorLabels: PropTypes.shape({}),
  setLoader: PropTypes.func,
  cartHaveGCItem: PropTypes.bool,
  singlePageCheckout: PropTypes.bool,
  shouldExpressAfterPayPopupOpen: PropTypes.bool,
  calculatedEstimatedTax: PropTypes.number,
  startExpressCheckoutHandler: PropTypes.func,
  trackAnalyticsClick: PropTypes.func,
  allCouponList: PropTypes.shape([]),
  isLoggedIn: PropTypes.bool,
  setAfterPayDrawerActn: PropTypes.func,
  showCouponsDrawer: PropTypes.bool,
  setOrderDetailsPartial: PropTypes.func,
  estimatedTaxReduxTTLValue: PropTypes.number,
  setEstimatedTax: PropTypes.func,
};

AfterPayExpress.defaultProps = {
  className: '',
  checkoutWithAfterPay: () => {},
  pickupStoresInCart: {},
  pickupInformation: {},
  isOrderHasPickup: false,
  setErrorState: () => {},
  errorLabels: {},
  setLoader: () => {},
  cartHaveGCItem: false,
  singlePageCheckout: false,
  calculatedEstimatedTax: 0,
  shouldExpressAfterPayPopupOpen: false,
  startExpressCheckoutHandler: () => {},
  trackAnalyticsClick: () => {},
  allCouponList: [],
  isLoggedIn: false,
  setAfterPayDrawerActn: () => {},
  showCouponsDrawer: false,
  setOrderDetailsPartial: () => {},
  estimatedTaxReduxTTLValue: 0,
  setEstimatedTax: () => {},
};

export default withStyles(AfterPayExpress, styles);
export { AfterPayExpress as AfterPayExpressVanilla };
